import styled, {css} from 'styled-components'
import {Dialog, DialogHeader} from '@/components/ui/dialog-atoms/DialogAtoms'

export const StyledDialog = styled(Dialog)`
    display: grid;
    grid-template-rows: auto minmax(0, 1fr) auto;
`

export const StyledDialogHeader = styled(DialogHeader)(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 4}px;
        align-items: flex-start;
        padding: ${spacing * 4.5}px ${spacing * 6}px;
    `
)

export const StyledTotalScore = styled.div(
    ({theme: {spacing, palette, typography}}) => css`
        border-radius: 6px;
        background-color: ${palette.neutral[50]};
        border: 1px solid ${palette.neutral[200]};
        padding: ${spacing * 3}px;
        ${typography.textSm};
        font-weight: 500;
    `
)
